import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/services/config.service';
import { RequestService } from '../../../../core/services/request.service';

import { BankingDataDetails } from './details/banking-data-details.model';

@Injectable()
export class BankingDataService {

   constructor(
    private configService: ConfigService,
    private requestService: RequestService
  ) { }

  delete(details: any): Observable<BankingDataDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.bankingData.delete.api;
        return this.requestService.post(url, details);
  }
  getBankingDataDetails(id: string): Observable<BankingDataDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.bankingData.details.api + '/' + id;
        return this.requestService.get(url);
  }
  getFields() {
     let fields = [
        {
            key: 'id',
            label: 'ID',
            type: 'hidden',
            required: false
        }, {
            key: 'bankName',
            label: 'Bank Name',
            type: 'textbox',
            required: true
        }, {
            key: 'address',
            label: 'Address',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
              this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.address.api
        }, {
            key: 'currency',
            label: 'Currency',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
              this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.currency.api
        }, {
            key: 'BIC/SWIFTCode',
            label: 'BIC/SWIFT code',
            type: 'textbox',
            required: false
        }, {
            key: 'bankKey',
            label: 'Bank Key',
            type: 'textbox',
            required: false
        }, {
            key: 'keySortCode',
            label: 'Key Sort Code',
            type: 'textbox',
            required: false
        }, {
            key: 'accountNumber',
            label: 'Account Number',
            type: 'textbox',
            required: false
        }, {
            key: 'IBAN',
            label: 'IBAN',
            type: 'textbox',
            required: false
        }, {
            key: 'accountHolderName',
            label: 'Account Holder Name',
            type: 'textbox',
            required: false
        }
     ];
     return fields;
  }

  getDetailsFields() {
      let fields = [
        {
            key: 'bankName',
            label: 'Bank Name',
            type: 'text'
        }, {
            key: 'address.id',
            label: 'Address',
            type: 'text'
        }, {
            key: 'currency',
            label: 'Currency',
            type: 'text'
        }, {
            key: 'bicSwiftCode',
            label: 'BIC/SWIFT code',
            type: 'text'
        }, {
            key: 'additionalName',
            label: 'Additional Name:',
            type: 'text'
        }, {
            key: 'currency',
            label: 'Currency:',
            type: 'text'
        }, {
            key: 'bankKey',
            label: 'Bank Key',
            type: 'text'
        }, {
            key: 'keySortCode',
            label: 'Key Sort Code',
            type: 'text'
        }, {
            key: 'accountNumber',
            label: 'Account Number',
            type: 'text'
        }, {
            key: 'iban',
            label: 'IBAN',
            type: 'text'
        }, {
            key: 'accountHolderName',
            label: 'Account Holder Name',
            type: 'text'
        }
     ];
     return fields;
  }
  getEditFields() {
     let fields = [
        {
            key: 'id',
            label: 'ID',
            type: 'hidden',
            required: false
        }, {
            key: 'bankName',
            label: 'Bank Name',
            type: 'textbox',
            required: true
        }, {
            key: 'address',
            label: 'Address',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
              this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.address.api
        }, {
            key: 'currency',
            label: 'Currency',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
              this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.currency.api
        }, {
            key: 'BIC/SWIFTCode',
            label: 'BIC/SWIFT code',
            type: 'textbox',
            required: false
        }, {
            key: 'bankKey',
            label: 'Bank Key',
            type: 'textbox',
            required: false
        }, {
            key: 'keySortCode',
            label: 'Key Sort Code',
            type: 'textbox',
            required: false
        }, {
            key: 'accountHolderName',
            label: 'Account Holder Name',
            type: 'textbox',
            required: false
        }
     ];
     return fields;
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/banking-data/banking-data.service.ts